/* eslint-disable react/jsx-props-no-spreading */

import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { isEmpty, isEqual } from "@utils/lodash";
import { EmptyCard } from "@components/common";
import CoreTable from "./CoreTable";
import { Loader } from "../../../components";

class Table extends Component {
	shouldComponentUpdate = ({
		columns,
		data,
		sortedColumn,
		rowKey,
		asc,
		loading,
		smallLoading,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(columns, lastProps.columns) ||
			!isEqual(data, lastProps.data) ||
			!isEqual(sortedColumn, lastProps.sortedColumn) ||
			!isEqual(rowKey, lastProps.rowKey) ||
			!isEqual(asc, lastProps.asc) ||
			!isEqual(loading, lastProps.loading) ||
			!isEqual(smallLoading, lastProps.smallLoading)
		);
	};

	render() {
		const { data, loading, smallLoading, isReport, ...props } = this.props;

		return (
			<div className="legacy">
				<div className="table-container">
					<CoreTable
						{
							...props /* eslint-disable-line react/jsx-props-no-spreading */
						}
						data={data}
						isReport={isReport}
					/>
					<div className={classNames("padding-20", { hidden: !isEmpty(data) })}>
						<EmptyCard />
					</div>
					<Loader
						className="table-loader"
						active={loading}
						size={smallLoading ? "small" : "large"}
					/>
				</div>
			</div>
		);
	}
}
Table.propTypes = {
	columns: PropTypes.array.isRequired,
	data: PropTypes.array,
	className: PropTypes.string,
	sortedColumn: PropTypes.string,
	rowKey: PropTypes.string,
	asc: PropTypes.bool,
	loading: PropTypes.bool,
	smallLoading: PropTypes.bool,
	onSortColumn: PropTypes.func,
	onRow: PropTypes.func,
	isReport: PropTypes.bool,
};

Table.defaultProps = {
	data: [],
	className: undefined,
	loading: false,
	smallLoading: false,
	sortedColumn: "Date",
	rowKey: "Id",
	asc: false,
	onSortColumn: undefined,
	onRow: () => {},
	isReport: false,
};

export default Table;
